import {TransportShiftTimelineEvent, transportType} from '@ots-frontend/ots-data';
import {ActionIcon, Switch, Text, ThemeIcon} from '@mantine/core'
import {useTranslation} from "react-i18next";
import {FormattedDateTime} from '../../date/FormattedDateTime/FormattedDateTime';
import {useMemo} from "react";
import {IconCircleFilled} from "@tabler/icons-react";
import {getFormattedDatabaseCode} from '../../text/FormattedDatabaseCode/FormattedDatabaseCode';
import {DefaultText} from '../../text/DefaultText/DefaultText';
import {getFormattedQuantity} from '../../text/FormattedQuantity/FormattedQuantity';

type Props = {
  event: TransportShiftTimelineEvent;
  onClick?: (event: TransportShiftTimelineEvent) => void
  onChecked?: (event: TransportShiftTimelineEvent, value: boolean) => void
};

export const TransportTimelineItemTitle = (props: Props) => {
  const {event} = props;

  const {t} = useTranslation(["common"])

  const title = useMemo(() => {
    if (event.transportType === transportType.pickup) {
      return t("common.entity.transport.timeline.transport.title.pickup", "Load Picked-Up")
    } else {
      return t("common.entity.transport.timeline.transport.title.delivery", "Load Delivered")
    }
  }, [t, event.transportType])

  return <>{title}</>
}

export const TransportTimelineItemBullet = (props: Props) => {
  const {event, onClick} = props;

  const color = useMemo(() => {
    return event.transportType === transportType.pickup
      ? "dispatch-request-picked-up"
      : "dispatch-request-completed";
  }, [event.transportType])

  if (onClick) {
    return (
      <ActionIcon
        size={22}
        color={color}
        radius="xl"
        onClick={() => onClick(event)}
      >
        <IconCircleFilled size={12}/>
      </ActionIcon>
    )
  } else {
    return (
      <ThemeIcon
        size={22}
        color={color}
        radius="xl"
      >
        <IconCircleFilled size={12}/>
      </ThemeIcon>
    )
  }
}

export const TransportTimelineItem = (props: Props) => {
  const {event, onChecked} = props;

  const {t} = useTranslation(["common"])

  return (
    <>
      <Text color="dimmed" size="sm">
        {t("ots.ui.entity.transport.timeline.title", "{{type}} of {{qty}} {{freightTypeName}}", {
          type: getFormattedDatabaseCode(event.transportType, t),
          qty: getFormattedQuantity(event.quantity, event.unitOfMeasure),
          freightTypeName: event.waterTypeName ?? t("common.shared.unknown", "Unknown")
        })}
      </Text>

      {event.serviceTypeId &&
        <Text c="service-work" size="sm">
          <DefaultText value={event.serviceTypeName}/>
        </Text>
      }

      <Text size="xs" mt={4}>
        <FormattedDateTime date={event.date}/>
      </Text>

      {onChecked &&
        <Switch
          m="md"
          size="xs"
          color="gray"
          label={t("common.action.show", "Show")}
          checked={event.selected}
          onChange={(e) => onChecked(event, e.currentTarget.checked)}
        />
      }
    </>
  );
};

TransportTimelineItem.Title = TransportTimelineItemTitle
TransportTimelineItem.Bullet = TransportTimelineItemBullet;
